/* A tiny history router: /, /p/:id, /my, /find, /admin. */

import { useEffect, useState } from 'react';

export type Route = { name: 'start' } | { name: 'project'; id: string } | { name: 'my' } | { name: 'find' } | { name: 'admin' };

export function parse(path: string, search = ''): Route {
  const q = new URLSearchParams(search);
  const fromHandoff = q.get('project');
  if (fromHandoff && /^[0-9a-f-]{36}$/i.test(fromHandoff)) return { name: 'project', id: fromHandoff };
  const m = /^\/p\/([0-9a-f-]{36})\/?$/i.exec(path);
  if (m) return { name: 'project', id: m[1] };
  if (/^\/my\/?$/.test(path)) return { name: 'my' };
  // Find My Gangsheets (0.3e Stage B): the link in the confirmation email
  if (/^\/find\/?$/.test(path)) return { name: 'find' };
  if (/^\/admin\/?$/.test(path)) return { name: 'admin' };
  return { name: 'start' };
}

const listeners = new Set<() => void>();

export function navigate(path: string, replace = false) {
  if (location.pathname + location.search === path) return;
  history[replace ? 'replaceState' : 'pushState'](null, '', path);
  listeners.forEach(l => l());
}

export function useRoute(): Route {
  const [r, setR] = useState(() => parse(location.pathname, location.search));
  useEffect(() => {
    const on = () => setR(parse(location.pathname, location.search));
    listeners.add(on);
    window.addEventListener('popstate', on);
    return () => { listeners.delete(on); window.removeEventListener('popstate', on); };
  }, []);
  return r;
}
